import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { InputStateToken, InputTypeToken, TextInputTypeToken, } from '@voltmoney/schema';
import TextInput from '../textInput/TextInput';
/**
 * Primary UI component for user interaction
 */
const CitySelectionInput = ({ label, value, placeholder, action, triggerAction }) => {
    const handleClick = () => {
        action && triggerAction && (triggerAction(action));
    };
    const _child = useMemo(() => {
        return (React.createElement(TextInput, { type: InputTypeToken.DEFAULT, state: InputStateToken.SELECTION, title: label ? label : '', value: value ? value : '', isFocus: false, placeholder: placeholder ? placeholder : '', width: TextInputTypeToken.FULL, onPress: () => handleClick() }));
    }, [label, value, placeholder]);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                width: '100%',
            } }, _child)));
};
export default memo(CitySelectionInput);
export { CitySelectionInput };
